// extracted by mini-css-extract-plugin
export var alpha = "_b2-4";
export var alphaInputContainer = "_b2-f";
export var badge = "_b2-b";
export var controls = "_b2-5";
export var formatDropdown = "_b2-d";
export var formatSelector = "_b2-c";
export var hex = "_b2-6";
export var hexInput = "_b2-e";
export var hue = "_b2-3";
export var hueAndAlphaPointer = "_b2-a";
export var percentageLabel = "_b2-g";
export var picker = "_b2-0";
export var rgba = "_b2-8";
export var rgbaSection = "_b2-7";
export var saturation = "_b2-1";
export var saturationPointer = "_b2-9";
export var sliders = "_b2-2";